var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3358 7.05383L16.4041 0H14.9661L9.69711 6.12491L5.48867 0H0.634521L6.99833 9.26184L0.634521 16.6592H2.07254L7.63671 10.1908L12.0814 16.6592H16.9355L10.3352 7.05383H10.3358ZM8.36605 9.34347L7.72134 8.42122L2.59064 1.08251H4.79965L8.94012 7.00485L9.58483 7.9271L14.9667 15.6256H12.7577L8.36605 9.34347Z",
    fill: "#363870"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d1afc52256eab2477ba7e5fe0b45b8d1.svg";
export { ForwardRef as ReactComponent };